import { useEffect, useState } from 'react';

import { useCatalogBrowsingTypeQuery } from '@domains/pdp-common';

const BOTTOM_FLOATING_CLASS_NAME = '.pdp__bottomFloating';
const SCROLL_GUIDE_KEY = 'brand_recommend_scroll_guide';
const GUIDE_TIME = 5000;

export const useScrollGuideService = () => {
  const { isNative } = useCatalogBrowsingTypeQuery();

  const [bottom, setBottom] = useState(0);
  const [visible, setVisible] = useState(false);
  const [is_revealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const floating_element = document.querySelector(BOTTOM_FLOATING_CLASS_NAME);
    if (floating_element) {
      const height = floating_element.getBoundingClientRect().height;
      setBottom(height);
    }
    if (isNative) {
      setBottom(0);
    }
  }, [isNative]);

  useEffect(() => {
    try {
      if (typeof Storage !== 'undefined') {
        const is_guide_revealed = localStorage.getItem(SCROLL_GUIDE_KEY);
        if (is_guide_revealed || is_guide_revealed === 'true') {
          setIsRevealed(true);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    if (visible) {
      try {
        localStorage.setItem(SCROLL_GUIDE_KEY, 'true');
        setIsRevealed(true);
        setTimeout(() => {
          setVisible(false);
        }, GUIDE_TIME);
      } catch (e) {
        console.error(e);
      }
    }
  }, [visible]);

  return {
    bottom,
    visible,
    setVisible,
    is_revealed,
  };
};
